import { Client } from './../client/client';

import { Component, OnInit, Input, Pipe, PipeTransform, ViewChild, QueryList, ViewChildren } from '@angular/core';
import { Ticket } from '../ticket/ticket';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { TicketService } from './../ticket/ticketService';
import { UserService } from '../_services';
import { User } from '../user/user';
import { TicketviewService } from '../ticketview/ticketviewService';
import { Authenticate } from '../authenticate/authenticate';
import { Machine } from '../machine/machine';
import { TruncatePipe } from '../_services/truncate';
import * as XLSX from 'xlsx';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-repairreport',
  templateUrl: './repairreport.component.html',
  styleUrls: ['./repairreport.component.css', '../app.component.less']
})
export class RepairreportComponent implements OnInit {
  @Input() machineI: Machine;
  @Input() inClient: Client;
  tickets: Ticket[];
  ticket = new Ticket;
  currentuser: User;
  private location: Location;
  auth: Authenticate;
  _selectedstatusid: number = 1;
  querycriteria: string;
  searchquery: string;
  jwt: string;
  ticketCount: number = 0;
  p: Number = 1;
  count: Number = 10;
  _currentclient: Client;
  showTicketId = true;
  dateFrom: Date;
  dateTo: Date;
  _today: Date = new Date;
  showClient = true;
  showMachine = true;
  showTitle = true;
  showPostedBy = true;
  showStatus = true;
  showDoid = true;
  showDateOfTicket = true;
  showResolutionDateOfTicket = true;
  showMachineSerialNumber = true;
  showResolution = true;
  showDetails = true;

  loading = false;
  fileName: string = "Repairs Report Export.xlsx";

  sortColumn: string = '';
  sortDirection: string = 'asc';
  sortedTickets: any[] = [];


  constructor(private http: HttpClient,
    private ticketservice: TicketService,
    private userservice: UserService,
    private ticketviewservice: TicketviewService,
    private activateroute: ActivatedRoute,
    private trunk: TruncatePipe
  ) { }
  private userrole: string;

  //----------------------------------------------------------------------------------
  // PAGE LOAD FUNCTION
  //----------------------------------------------------------------------------------
  ngOnInit() {
  
    this.currentuser = this.userservice.getCurrentUserFromCookie();
    this.userrole = this.currentuser.role.name;
    const id = +this.activateroute.snapshot.paramMap.get('id');
    if (this.userrole == "Authenticated" || this.userrole == "Administrator") {
      if (id == 0) {
        this.ticketservice.getTicketsQl()
          .subscribe(response => {
            this.tickets = response.reverse();
            this.ticketCount = this.tickets.length
          });
      }
      else if (id > 0) {
        this.ticketservice.getClientTickets(id)
          .subscribe(response => {
            this.tickets = response.reverse();
            this.ticketCount = this.tickets.length
          });
      }
    }
    else {
      if (this.userrole = "clientsrole") {
        this.ticketservice.getClientTickets(this.currentuser.client.id).subscribe(res => {
          this.tickets = res;
          this._currentclient = this.currentuser.client;
        })
      }
    }

  }

  //----------------------------------------------------------------------------------
  // SET CURRENT TICKET TO TICKET BY ID VALUE
  //----------------------------------------------------------------------------------
  getTicketById(id: number) {
    this.ticketservice.getTicket(id).subscribe(ticket => this.ticket = ticket);
  }
  goBack(): void {
    this.location.reload;
  }

  //----------------------------------------------------------------------------------
  // CRITERIA SEARCH FUNCTION 
  //----------------------------------------------------------------------------------
  search(argument) {
    // Client is the criteria --> Search with Client Name QL function
    if (this.querycriteria == 'client') {
      // Administrative User Full Client's Search
      if (this.userrole == "Authenticated" || this.userrole == "Administrator") {
        this.ticketservice.getTicketsByClientNameQl(this.querycriteria, argument).subscribe(res => {
          this.tickets = res.reverse();
          this.ticketCount = this.tickets.length;
          this._currentclient = res[0].client;
        });
      }
      // Client User Only shows Client Tickets
      else {
        this.ticketservice.getTicketByCriteriaClient(this.querycriteria, argument, this.currentuser.client.id, this.jwt).subscribe(
          res => {
            this.tickets = res.reverse();
            this._currentclient = res[0].client;
          });
      }
    }
    // Criteria NOT CLIENT
    else {
      this._currentclient = null;
      console.log("AFter NULL" + this._currentclient);
      // Administrative User Full Client's Search
      if (this.userrole == "Authenticated" || this.userrole == "Administrator") {
        this.ticketservice.getTicketsByCriteriaQl(this.querycriteria, argument).subscribe(res => {
          this.tickets = res.reverse();
          this.ticketCount = this.tickets.length;
        });
      }
      // Client User Only TICKETS
      else {
        this._currentclient = this.currentuser.client;
        this.ticketservice.getTicketByCriteriaClient(this.querycriteria, argument, this.currentuser.client.id, this.jwt).subscribe(res => { this.tickets = res.reverse() });
      }
    }
  }

  //----------------------------------------------------------------------------------
  // DATE SEARCH FUNCTION FROM --> TO
  //----------------------------------------------------------------------------------
  searchByDate(argument) {
    // CRITERIA AND DATE RANGE SEARCH
    if (this.searchquery) {
      // ADMIN USER FULL SEARCH FILTERS
      if (this.userrole == "Authenticated" || this.userrole == "Administrator") {
        // Client as Query Criteria
        if (this.querycriteria == "client") {
          this.ticketservice.getTicketsByClientDateRangeQl(argument, this.dateFrom, this.dateTo).subscribe(res => {
            this.tickets = res.reverse();
            this.ticketCount = this.tickets.length;
            try {
              this._currentclient = this.tickets[0].client;
            }
            catch {
            }
          });
        }
        // Other Query Criteria
        else {
          this._currentclient = null;
          this.ticketservice.getTicketsByCriteriaDateRangeQl(this.querycriteria, argument, this.dateFrom, this.dateTo).subscribe(res => {
            this.tickets = res.reverse();
            this.ticketCount = this.tickets.length;
          });
        }
      }
      // Client USER
      else {
        this._currentclient = this.currentuser.client;
        this.ticketservice.getTicketsByClientCriteriaDateRangeQl(this.currentuser.client.name, this.querycriteria, argument, this.dateFrom, this.dateTo).subscribe(res => this.tickets = res.reverse());
      }
    }
    // No Criteria is in the search argument
    else {
      // ADMIN FULL SEARCH 
      if (this.userrole == "Authenticated" || this.userrole == "Administrator") {
        this.ticketservice.getTicketsByDateRangeQl(this.dateFrom, this.dateTo).subscribe(res => {
          this.tickets = res.reverse();
          this.ticketCount = this.tickets.length;
        });
      }
      // Client USER
      else {
        this._currentclient = this.currentuser.client;
        this.ticketservice.getTicketsByClientDateRangeQl(this.currentuser.client.name, this.dateFrom, this.dateTo).subscribe(res => this.tickets = res.reverse());
      }
    }
  }

  //----------------------------------------------------------------------------------
  // EXPORT TABLE TO EXCEL
  //----------------------------------------------------------------------------------
  exportexcel(): void {
    /* pass here the table id */
    var pipe = new DatePipe('en-US');
    const now = Date.now();
    const myFormattedDate = pipe.transform(now, 'short');
    if (this._currentclient) {
      this.fileName = this._currentclient.name + "_Repairs Report_" + myFormattedDate + ".xlsx";
    }
    else {
      this.fileName = "Repairs Report_" + myFormattedDate + ".xlsx";
    }
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }

  //----------------------------------------------------------------------------------
  // EXPORT TABLE TO EXCEL WITH SPINNER 
  //----------------------------------------------------------------------------------
  exportExcelWithSpinner() {
    this.loading = true;
    // Your export logic here...
    setTimeout(() => {
      this.exportexcel();
      this.loading = false;
    }, 500);  // Simulate a 2-second delay
  }


  //--------------------------------------------------------------------------------
  // SEARCH FUNCTION BY DATE
  //--------------------------------------------------------------------------------
  searchByDateWithSpinner(query: string) {
    this.loading = true;
    // Your search logic here...
    setTimeout(() => {
      this.searchByDate(query);
      this.loading = false;
    }, 500);  // Simulate a 2-second delay
  }




  //--------------------------------------------------------------------------------
  // SORTING TABLE WITH HEADER AS ARGUMENT
  //--------------------------------------------------------------------------------
  sortData(column: string) {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
    this.sortTickets();
  }

  sortTickets() {
    this.tickets = this.tickets.sort((a, b) => {
      const aValue = this.getValue(a, this.sortColumn);
      const bValue = this.getValue(b, this.sortColumn);

      if (aValue < bValue) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (aValue > bValue) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
  }

  getValue(ticket: any, column: string): any {
    const keys = column.split('.');
    let value = ticket;
    for (const key of keys) {
      if (value) {
        value = value[key];
      }
    }
    return value;
  }
  //--------------------------------------------------------------------------------
  // END OF SORTING FUNCTION AND SUPPORTNG FUNCTIONS                              //
  //--------------------------------------------------------------------------------  

}


